/**
 * Collapsible one-levele dropdown navigation
 *
 * @param {string} dropdownButtonsSelector - selector for toggle buttons
 */

import { isItOpen, closeIt, openIt } from './utils/showHide';

export const navDropdown = (
    dropdownButtonsSelector = '#ghwp-main-nav li > button'
) => {
    const dropdownButtons = document.querySelectorAll(dropdownButtonsSelector);

    Array.prototype.forEach.call(dropdownButtons, (dropdownButton) => {
        dropdownButton.addEventListener('click', function () {
            let expanded = isItOpen(this);
            if (!expanded) {
                // the clicked one is closed, open it + close the others
                const shouldClose = [...dropdownButtons].filter(
                    (btn) => btn !== this
                );
                shouldClose.forEach((el) => closeIt(el));
                openIt(this);
            } else {
                // the clicked one is open, close it
                closeIt(this);
            }
        });
    });
};
